export default {
  ready: "ready",
  loading: "loading",
  initial: "initial",
  error: "error",
}
